import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import Logo from "../../assets/logo.png";
import Bars from "../../assets/bars.png";
import Close from "../../assets/close.png";
import { Link } from "react-scroll";

const menuItems = [
  { label: "Inicio", to: "hero" },
  { label: "Programas", to: "programs" },
  { label: "Beneficios", to: "reasons" },
  { label: "Equipo", to: "team" },
  { label: "Horarios", to: "schedule" },
  { label: "Testimonios", to: "testimonials" },
  { label: "Contacto", to: "contact" },
];

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const menuRef = useRef(null);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setMenuOpened(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close menu on outside click
  useEffect(() => {
    if (!menuOpened) return;

    const handleOutsideClick = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !e.target.closest(".menu-toggle")
      ) {
        setMenuOpened(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () =>
      document.removeEventListener("mousedown", handleOutsideClick);
  }, [menuOpened]);

  return (
    <>
      {/* Backdrop */}
      {menuOpened && isMobile && (
        <div
          className="menu-backdrop"
          onClick={() => setMenuOpened(false)}
        />
      )}

      <header className="header">
        <img src={Logo} alt="Logo" className="logo" />

        {/* Mobile Toggle Button */}
        {isMobile && (
          <button
            className="menu-toggle"
            aria-label="Toggle navigation menu"
            onClick={(e) => {
              e.stopPropagation();
              setMenuOpened((prev) => !prev);
            }}
          >
            <img
              src={menuOpened ? Close : Bars}
              alt="Menu Icon"
              className="menu-icon"
            />
          </button>
        )}

        {/* Menu */}
        {(menuOpened || !isMobile) && (
          <ul
            ref={menuRef}
            className={`header-menu ${menuOpened ? "open" : ""}`}
          >
              {menuItems.map(({ label, to }) => (
                <li key={to}>
                <Link
                  to={to}
                  smooth={true}
                  spy={true}
                  offset={-80}
                  duration={600}
                  onClick={() => setMenuOpened(false)}
                >
                  {label}
                </Link>
              </li>
              )
            )}
          </ul>
        )}
      </header>
    </>
  );
};

export default Header;
